import React from "react";
import styles from "./transaction.module.css";
import { formatDateAndTime } from "../../utils/utils";
const formatText = (text) => {
  if (typeof text !== "string") return text;
  return text
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

function TransactionMainDetail({ canvasData }) {
  return (
    <table className={styles.details}>
      <tbody>
        <tr>
          <td>Transaction ID:</td>
          <td className={styles.textMuted}>
            {canvasData.transaction_transaction_id || "--"}
          </td>
        </tr>
        <tr>
          <td>Transaction Number:</td>
          <td className={styles.textMuted}>
            {canvasData.transaction_transaction_no || "--"}
          </td>
        </tr>
        <tr>
          <td>Created At:</td>
          <td className={styles.textMuted}>
            {formatDateAndTime(canvasData.transaction_created_at)}
          </td>
        </tr>
        <tr>
          <td>Status:</td>
          <td className={styles.textMuted}>
            {canvasData.transaction_status || "--"}
          </td>
        </tr>
        {canvasData.transaction_type !== "FUND_RECEIVED" && (
          <tr>
            <td>Amount Sent:</td>
            <td className={styles.textMuted}>
              {canvasData.transaction_debit_amount
                ? `${canvasData.transaction_from_currency} ${canvasData.transaction_debit_amount}`
                : "--"}
            </td>
          </tr>
        )}
        <tr>
          <td>Amount Recieved:</td>
          <td className={styles.textMuted}>
            {canvasData.transaction_amount ? `${canvasData.transaction_to_currency} ${canvasData.transaction_amount}` : "--"}
          </td>
        </tr>
        <tr>
          <td>Transaction Type:</td>
          <td className={styles.textMuted}>
            {formatText(canvasData.transaction_type) || "--"}
          </td>
        </tr>
        <tr>
          <td>Transaction Fees:</td>
          <td className={styles.textMuted}>
            {`${
              canvasData.transaction_from_currency || ""
            } ${canvasData.transaction_fees || "0"} `}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default TransactionMainDetail;
